import axios from "axios";
import { apiUrls } from "settings";
import { trimEndSlash } from "utils/urlHelper";

export const getApplication = async () => {
    const response = await axios.get(trimEndSlash(apiUrls.getApplication));

    return response;
};
